export default {
  'tips.login': '系统登录中',
  'tips.clearCacheTips': '您保存的自定义搜索、列表宽度、列选择将恢复默认，是否继续？',
  'tips.uploadMessage': '存在未执行完毕的导入任务，请收到执行完毕的通知信息后再进行导入！',
  'tips.apaasTransfer': 'Apaas同步的线索不支持直接在烽火转移，请前往Apaas系统操作',
  'tips.phoneNumber': '请填写带区号的固定电话或手机号',
  'tips.phoneRules': '请填写手机号或带区号的固定电话(比如：11位手机号或者010-1234xxxx)',
  'tips.phoneNumberRules': '联系电话仅支持：11位国内手机号、固话：010-1234567 010-12345678',
  'tips.confimShedule': '自动生成的飞书日程及飞书任务也将同步删除，请确认！',
  'tips.phone': '联系电话仅支持：11位国内手机号',
  'tips.numberRules': '固话：010-1234567 010-12345678',
  'tips.uploadAlert': '数据导入中，完成后将发出消息提醒',
  'tips.deleteContact': '是否确认删除该联系人及其下级联系人',
  'tips.failedAgainLater': '获取链接失败，请稍后再试',
  'tips.companyNameExists': '公司名称已存在，请重新填写',
  'tips.userPhoneExists': '联系方式已存在，请重新填写',
  'tips.onlyImporting': '仅支持导入.xlsx格式的文件',
  'tips.uploadFailedIsLarge': '上传失败,文件大小不能超过20M',
  'tips.dashboard': '记录当下超2日还未处理线索数量，与时间范围无关，点击可跳转销售线索查看所有超2日未处理线索详情',
  'tips.call': '统计所选时间范围内发生的外呼通话中，接通的次数',
  'tips.leads': '分配线索数： 分配的线索总数',
  'tips.leadsNum': '40分钟内跟进线索数： 线索中40分钟内跟进的线索数量，包含添加跟进或产生通话记录',
  'tips.leadsRate': '线索及时跟进率： 40分钟内跟进线索数/分配线索数，指标越高，表明跟进越及时',
  'tips.updateLeads': '统计新增线索数以及是否及时跟进',
  'tips.leadsDetail': '可跳转销售线索查看所有待处理与待定的线索详情',
  'tips.priceDetail': '一个报价单至少要添加一个报价明细',
  'tips.priceApprove': '已提交审批！请关注审批动态',
  'tips.feishu': '同步的飞书合同需要手工关联客户，否则无法下单',
  'tips.noFeishu': '非飞书合同自动创建，无法查看飞书合同详情!',
  'tips.winnering': '合同结束日期不能早于开始日期！',
  'tips.contractDetail': '一个销售合同至少要添加一个明细',
  'tips.exportFileAlert': '导出后的文件将通过消息卡片进行通知',
  'tips.chooseUser': '请选择人员，仅支持选择租户内人员',
  'tips.closePermissions': '转化客户成功后将关闭该线索所有编辑权限！',
  'tips.apassInvert': 'Apaas同步的线索只能转化为客户，不能转化为商机！',
  'tips.synchronous': '线索联系人、通话、日程、动态记录痕迹同步至所转化对象！',
  'tips.customerExists': '客户已存在，可联系当前负责人共同协作!',
  'tips.customerIsRequired': '未关联工商信息！',
  'tips.opportunityExists': '商机已存在，可联系当前负责人共同协作!',
  'tips.dataExport': '数据导出中，导出后的文件将通过消息卡片进行通知',
  'tips.voidPricesheet': '请确认是否作废报价单，作废后将不能恢复？',
  'tips.voidContract': '请确认是否作废合同，作废后将不能恢复？',
  'tips.voidOrder': '请确认是否作废订单，作废后将不能恢复？',
  'tips.notOpportunity': '客户未关联工商信息，不可直接新建商机！',
  'tips.deleteImgAlert': '您确定要删除这张图片吗',
  'tips.changePerson1': '一并变更的数据仅是负责人为当前客户的负责人，不是该客户负责人的数据不会变更。',
  'tips.changePerson2': '一并变更的数据仅是负责人为当前商机的负责人，不是该商机负责人的数据不会变更。',
  'tips.changePerson3': '一并变更的数据仅是负责人为当前对象的负责人,不是该对象负责人的数据不会变更。',
  'tips.addPriceErr': '客户未关联工商信息暂无法新建报价单！',
  'tips.addPriceError': '未关联客户的商机暂无法新建报价单！',
  'tips.noPrimisson': '暂无商机关联客户的协作权限！',
  'tips.addContractErr': '客户未关联工商信息暂无法新建销售合同！',
  'tips.addContractError': '未关联客户的商机暂无法新建销售合同！',
  'tips.addOrderErr': '客户未关联工商信息暂无法新建销售订单！',
  'tips.addOrderError': '未关联客户的商机暂无法新建销售订单！',
  'tips.voidDeleteAnnex': '确认是否要删除此附件？若附件关联有任务，删除后将无法查看附件！',
  'tips.limitNumber': '单次上传需限制数量，最大支持单次上传10个文件',
  'tips.limitTen': '单次上传最多支持10个文件',
  'tips.fileExists': '文件已存在，无需重复上传',
  'tips.notDataCreat': '暂无数据，可新建开票信息',
  'tips.uploadError': '上传失败,文件大小不能超过',
  'tips.notSave': '点击后，本次操作记录将不做保存！',
  'tips.contractLimits': '暂无此销售合同查看权限',
  'tips.contractCurren': '一个报价单只能选择相同币种的价格',
  'tips.contractPrice': '已过期价格不可选',
  'tips.noProduct': '该产品已不存在，无法查看',
  'tips.buyTime1': '一、请根据时长单位选项填写',
  'tips.buyTime2': '若时长单位选“年”，这里就填*年',
  'tips.buyTime3': '若时长单位选“月”，这里就填*月',
  'tips.buyTime4': '若时长单位选“天”，这里就填*天',
  'tips.buyTime5': '若时长单位选“小时”，这里就填*小时',
  'tips.buyTimeTitle': '二、关于时长的换算规则',
  'tips.buyTime6': '1年=365天',
  'tips.buyTime7': '1月=30天',
  'tips.changeProduct': '请选择产品名称',
  'tips.noPriceAccess': '暂无该报价单的查看权限',
  'tips.apaasOpportunity': 'Apaas同步的商机不支持直接在烽火转移，请前往Apaas系统操作',
  'tips.nextConfirm': '请确认是否直接推进至下一阶段？',
  'tips.plaseOver': '请先完成本阶段所有任务！',
  'tips.backNext': '确认回退到当前选中阶段吗？',
  'tips.hasPerformance': '该业绩参与人已增加该协作阶段，不可重复新增',
  'tips.aPaas': 'Apaas同步商机需要手动关联客户，否则无法下单',
  'tips.noProductAccess': '暂无此产品查看权限',
  'tips.saveProduct': '请先保存产品基本信息',
  'tips.sweet': '温馨提示',
  'tips.remove': '是否确认删除此价格？',
  'tips.productRep': '产品名称重复，请重新输入',
  'tips.saveOrder': '提交并按明细拆分：提交后自动根据明细行生成多个订单，有多少明细行就生成多少订单',
  'tips.distanceTotal': '客户折后总价(含税)-合计',
  'tips.orderDetail': '一个销售订单至少要添加一个明细',
  'tips.noContract': '未选择合同（如无合同，请上传打款截图或其他凭证）',
  'tips.annualContract': '连年合同必须将产品按年拆分成多个明细，即每个明细的停服日期-开服日期不能大于1年',
  'tips.moreCurrency': '明细中存在多种货币类型，请统一类型后提交',
  'tips.noExitsProduct': '该产品已不存在，无法查看',
  'tips.notAddress': '暂无地址，可新建地址信息',
  'tips.myCostomer': '这里只展示自己负责和协作的客户，若客户已存在但自己不能关联，可联系客户负责人共同协作!',
  'tips.download': '通话明细-通话视角数据下载出错',
  'tips.downloadByCall': '通话明细-通话视角数据下载出错',
  'tips.downloadByPer': '通话明细-人员视角数据下载出错',
  'tips.delLeads': '该线索已删除，不可查看详情',
  'tips.delCustomer': '该客户已删除，不可查看详情',
  'tips.delOp': '该商机已删除，不可查看详情',
  'tips.joinSuccess': '加入成功，请关注飞书会议进程',
  'tips.joinError': '入会失败，请重试或联系管理员',
  'tips.calendarError': '日历数据统计获取失败',
  'tips.downClueError': '超两日待处理线索下载出错',
  'tips.callNum': '统计所选时间范围内发生的外呼通话中，接通的次数',
  'tips.clueNum': '记录当下超2日还未处理线索数量，与时间范围无关，无走势图信息',
  'tips.clueSkip': '点击可跳转销售线索查看所有超2日未处理线索详情',
  'tips.default': '默认规则展示：≤1天时按照时间段展示，>1天按日展示',
  'tips.top10': '图表只展示top10,切换表格展示全部信息',
  'tips.top20': '图表只展示top20,切换表格展示全部信息',
  'tips.pendingClueError': '待处理线索下载出错',
  'tips.personageError': '个人指标报表下载出错',
  'tips.addClueNum': '统计新增线索数以及是否及时跟进',
  'tips.allotClue': '分配线索数： 分配的线索总数',
  'tips.closeRuleAlert': '停用后该规则将不再生效，是否停用？',
  'tips.closeStageAlert': '停用后该字段将不再可用，是否确认？',
  'tips.followUpRate': '线索跟进率：新线索当前已跟进（跟进建议不再为待处理）',
  'tips.followUpClueRate': '线索及时跟进率：新线索在40分钟内跟进（有首电或有动态记录）',
  'tips.customerNum': '展示各发展阶段客户量对比，如线索中未维护发展阶段标签，则数据不做统计',
  'tips.allotClueNum': '40分钟内跟进线索数： 线索中40分钟内跟进的线索数量，包含添加跟进或产生通话记录',
  'tips.allotClueRate': '线索及时跟进率： 40分钟内跟进线索数/分配线索数，指标越高，表明跟进越及时',
  'tips.statisticsClue': '记录每人当下超2日未处理线索数量，与时间无关，图表只展示top10,切换表格展示全部信息',
  'tips.rolesAndor': '数据权限必须维护主规则，如不同数据对象有特殊要求，可设置补充规则,主规则与补充规则之间为“且”关系 ',
  'tips.removePerson': '删除后该员工将无法拨打，是否确认删除',
  'tips.phoneNum': '请填写带区号的固定电话或手机号',
  'tips.phoneNumRule': '请填写手机号或带区号的固定电话(比如：11位手机号或者010-1234xxxx)',
  'tips.callpoolFRepeat': '请输入外呼池编号，不可重复',
  'tips.delCallpool': '删除后,该号码池下的所有号码也将全部删除,确认删除号码池吗?',
  'tips.fixedPhoneNumber': '请填写固定电话或手机号',
  'tips.delPhoneNumber': '删除后该号码将不能使用,确认删除该号码？',
  'tips.stageNext': '如选是，支持在未完成阶段任务的情况下直接跨阶段',
  'tips.hasStageNext': '该阶段下已设置任务，无法设为结束节点，请前往下一步清除任务后重试',
  'tips.oppornotRepeat': '协作阶段不能重复，请重新选择',
  'tips.costomerEsc': '客户已创建商机、合同、订单等后续数据，如需作废，请先作废下游数据！',
  'tips.opportunityEsc': '商机已创建报价、合同、订单等后续数据，如需作废，请先作废下游数据！',
  'tips.stopViewAlert': '停用后该视图将不再可用，是否确认？',
  'tips.outobjDelete': '删除后该字段将不再可用，是否确认？',
  'tips.keyNotRepeat': '选项文本/key值不允许重复，无特殊需求，建议不要更改自动生成的选项key值',
  'tips.markData': '请确认是否作废该条数据，作废的数据不能恢复',
  'tips.removeRuleAlert': '删除后将不再可用，是否确认删除？',
  'tips.repeatSetting': '新建/编辑/导入时自动查询系统中是否已有重复信息',
  'tips.callphone': '拨打对方显示自己真实手机号，回拨自己显示对方真实号码',
  'tips.callphones': '拨打对方显示平台提供号码，回拨自己显示线路虚拟号',
  'tips.leadsRepeat': '1、销售线索的公司名称、联系方式与客户的客户名称、联系方式精准匹配。2、只有销售线索查重条件是公司名称、联系方式之一时，联合查重生效',
  'tips.advSearchNameRepeat': 'name值{ name }重复，请修改',
  'tips.advSearchCustomIsNotEmpty': 'custom类型的筛选，name值不能为空',
  'tips.noBackingOkin': '确认是否定为【{ name }】阶段？确认后将不可回退',
  'tips.noPromissionCustom': '暂无该客户协作权限，请联系该客户负责人将您加为客户协作人',
  'tips.repeatData': '编码（前编码/后编码）中未插入任何时间变量，会造成数据量过大时编码重复，请重新维护！',
  'tips.selectRepeat': '选项数据【{name}】重复，请修改',
  'tips.allocationReason': '{xxx} 将 <span style="font-weight:700">{aaa}</span> 转移给 {yyy}, 转移的原因是 {bbb}.',
  'tips.scheduleDetail': '{name}的日程详情({count})条',
  'tips.followRecord': '动态记录-动态记录视角数据',
  'tips.followRecordPerson': '动态记录-人员视角数据',
  'tips.followRecordError': '动态记录-动态记录视角数据下载出错',
  'tips.followRecordPersonError': '动态记录-人员视角数据下载出错',
  'tips.followPersonTitle': '{name}的动态记录({count})条',
  'tips.timesShowRules': '时间区间小于24小时，按小时为单位展示；大于24小时按日为单位展示',
  'tips.transferData': '请确认是否转移该条数据',
  'tips.delLayout': '删除后，将同步移除视图下已选择的该布局，并在该视图下分配默认布局。确认删除该布局吗？',
  'tips.defaultSort': '如不指定,默认按照数据创建时间降序排序',
  'tips.defaultMobile': '联系电话仅支持：11位国内手机号,',
  'tips.defaultMobileFixed': '固话：010-1234567 010-12345678',
  'tips.delModule': '分组下存在不可移除的字段，请先将这些字段移至其它分组后进行删除操作',
  'tips.delModuleSure': '确定删除此分组吗？',
  'tips.delModuleBox': '删除后，将会清空该分组下已选的字段，是否确认操作？',
  'tips.conditionsCount': '已添加:{count}个条件',
  'tips.conditionsConfig': '条件存在空值，请重新配置',
  'tips.isDeleteTab': '确认删除此页签吗？',
  'tips.isDeleteTabContent': '删除后，将会清空该页签下所有分组，是否确认操作？',
  'tips.isDeleteGroup': '确认删除此分组吗？',
  'tips.isDeleteGroupContent': '删除后，将清空该分组下已选择的字段并放入回收站、删除分组下已配置的组件，是否确认操作？',
  'tips.isDeleteBuiltTabContent': '删除后，该页签将不可见，是否确认操作？',
  'tips.sameCurrency': '明细行币种必须一致',
  'tips.bussinessCustomer': '先点击关联一个客户后，才能关联工商信息！',
  'tips.repeatAlert': '支持多个数据一次性查重，数据直接需要用英文“分号”分隔',
  'tips.delatePool': '删除后，员工的线索保有量上限将按照一般规则设置生效，是否确认?',
  'tips.formulas': '历史数据的值将会进行自动计算，计算任务已在排队中，请耐心等待！',
  'tips.importNewFile': '导入数据执行中，完成后将发送飞书消息通知操作人、数据负责人',
  'tips.importUpdataFile': '导入数据执行中，完成后将发送飞书消息通知',
  'tips.tableLevel': '提示:查询记录中增加的二级、三级表格仅支持数据展示，不支持新建、批量操作、编辑等其他任意操作。',
  'tips.tabsToOtherLayouts': '提示：将页签复制到其他布局时，将保留对当前页签下对于字段的属性设置。字段属性、字段显示条件、字段编辑条件配置等都会进行复制粘贴。',
  'tips.copyToOtherTips': '提示：将分组复制到其他页签时，保留对当前分组中对于字段的属性设置。字段属性、字段显示条件、字段编辑条件配置等都会进行复制粘贴。',
  'tips.moveToOtherTips': '提示：将分组移动到目标分组时，会将该分组变为所选目标分组的二级分组，移出动作表示将二级分组变为一级分组。',
  'tips.layoutSaveTitle': '默认布局初次修改，是否保存？',
  'tips.layoutSaveInfo': '本次保存后，表单设计页配置内容将不再对本默认布局进行全量内容同步，请确认是否要继续进行本次保存。',
  'tips.layoutSaveRemark': '备注:',
  'tips.layoutSaveRemark1': '1.本次保存「确定」后，后续进行布局保存时，将不再出现该提示；',
  'tips.layoutSaveRemark2': '2.表单设计中已有字段的字段属性会继续同步至本布局，但是已有字段的布局属性、字段位置等内容将不再进行同步；',
  'tips.layoutSaveRemark3': '3.表单设计中新增的字段(同步内容包含:字段的字段属性、字段的布局属性)、对字段进行删除动作将会继续同步至本布局中。',
  'tips.approveOpenInfo1': '1、选择直接触发审批，数据导入成功后生命状态会变为【审批中】，并直接发起审批（需等待导入数据触发的计算任务处理完成后发起）',
  'tips.approveOpenInfo2': '2、选择无需发起审批，数据导入成功后生命状态会变为【已生效】，且不可再发起审批',
  'tips.approveOpenInfo3': '3、选择完善后发起审批，数据导入成功后生命状态会变为【未生效】，可在完善信息后再次提交并发起审批',
  'tips.configurationField': '已配置：{num}个字段',
  'tips.associateRecord': '关联记录：可绑定关联表并在主表内以表格呈现，支持在主表中操作关联表数据，能同步填报主表与关联表数据并自动绑定关联关系。示例：订单管理中，在订单页面直接显示订单项表格，可新增、编辑商品及数量，填写订单信息时同步完成订单项与订单的关联。',
  'tips.queryRecord': '查询记录：作为单独的查询展示功能，可以自动查询出其他表单中满足条件的一条或多条数据。示例：客户管理中，在客户页面直接查询本客户的符合条件商机数据。'
};
